module.exports = __webpack_public_path__ + "static/media/Concept_Air_Realm.df81c1ca.jpg";